import { map, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { PromotionContent } from '@shared/models/promotion-content.model';
import { Pagination } from '@shared/models/pagination.model';
import { ApiResponse } from '@shared/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class PromotionContentDataService {

  messages$ = new Subject<any[]>();
  isSuccess: boolean;

  pagination: Pagination;
  constructor(private http: HttpClient) { }

  getAll(): Observable<PromotionContent[]>{
    return this.http.get<ApiResponse>('/promotion?locale_id=1').pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  getWithQuery(pageParam: string): Observable<PromotionContent[]>{
    return this.http.get<ApiResponse>(`/promotion${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  getPromotionCategory(){
    return this.http.get<ApiResponse>(`/promotion/category?status=1`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  promoApply(data: any){
    return this.http.post<ApiResponse>(`/promotion/apply`, data).pipe(
      tap(res => {
        this.messages$.next(res.message);
        this.isSuccess = res.success;
      }),
      map(res => res)
    );
  }

  claim(data: any){
    return this.http.post<ApiResponse>(`/promotion/claim`, data).pipe(
      tap(res => {
        this.messages$.next(res.message);
        this.isSuccess = res.success;
      }),
      map(res => res)
    );
  }

  getPromotion(pageParam = ''){
    return this.http.get<ApiResponse>(`/promotion/getpromotion?type=1&paginate=0${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  getDepositPromotion(pageParam = ''){
    return this.http.get<ApiResponse>(`/promotion/getdepositpromotion?${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  /* The new deposit flow's promotion list. Same shape as getDepositPromotion, different endpoint —
     v2 is scoped to the payment modes the member can actually use. */
  getDepositPromotionV2(pageParam = ''){
    return this.http.get<ApiResponse>(`/promotion/getdepositpromotionv2?${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  recheckDepositBonusDetail(promotion_id: any, deposit_amount: any){
    return this.http.get<ApiResponse>(`/promotion/recheckdepositbonus`, {
      params: { promotion_id: promotion_id, deposit_amount: deposit_amount }
    }).pipe(
      map(res => res.data)
    );
  }

  getPromotionList(){
    return this.http.get<ApiResponse>(`/promotion/promolist`).pipe(
      map(res => res.data)
    );
  }

  getMerchantBankPromotionList(merchantBankId: any){
    return this.http.get<ApiResponse>(`/promotion/getmerchantbankpromotionlist?merchant_bank_id=${merchantBankId}`).pipe(
      map(res => res.data)
    );
  }

  getPromotionFirstMerchantBank(promotionId: any){
    return this.http.get<ApiResponse>(`/promotion/getpromotionfirstmerchantbank?purpose_id=1&promotion_id=${promotionId}`).pipe(
      map(res => res.data)
    );
  }

  getWidget(){
    return this.http.get<ApiResponse>(`/promotion/getwidget`).pipe(
      map(res => res.data)
    );
  }
  
  getActivePromotion() {
    return this.http.get<ApiResponse>(`/promotion/activepromotion`).pipe(
      map(res => res.data)
    );
  }

  getBonusWinAmount(memberPromotionId: number) {
    return this.http.get<ApiResponse>(`/promotion/bonuswinamount?member_promotion_id=${memberPromotionId}`).pipe(
      map(res => res.data)
    );
  }

  selfCancelPromotion(data: any){
    return this.http.post<ApiResponse>(`/promotion/selfcancelpromotion`, data).pipe(
      tap(res => {
        this.messages$.next(res.message);
        this.isSuccess = res.success;
      }),
      map(res => res)
    );
  }

  cancelPendingPromotion(memberPromotionId: number){
    return this.http.post<ApiResponse>(`/promotion/${memberPromotionId}/pending/cancel`, null).pipe(
      tap(res => {
        this.messages$.next(res.message);
        this.isSuccess = res.success;
      }),
      map(res => res)
    );
  }

  checkIncompleteFreeSpin() {
    return this.http.get<ApiResponse>(`/memberpromotion/checkIncompleteFreeSpin`).pipe(
      map(res => res.data)
    );
  }

  private paginationInit(res: any) {
    if (res) {
      this.pagination = res.data.paginations;
    }
  }
}
